import type { CodeTemplate } from "./index";
import { readDirFiles } from "../readDirFiles.ts" with { type: "macro" };

type StepFile = { path: string; content: string };

type FullTemplateStep = {
  entryPoint?: string;
  defaultHasOutput: boolean;
  files: StepFile[];
};

export const templateStepFiles: Record<CodeTemplate, FullTemplateStep> = {
  shell: {
    entryPoint: "script.sh",
    defaultHasOutput: false,
    files: readDirFiles("templateSteps/shell"),
  },

  python: {
    entryPoint: "script.py",
    defaultHasOutput: false,
    files: readDirFiles("templateSteps/python"),
  },

  typescript: {
    entryPoint: "script.ts",
    defaultHasOutput: false,
    files: readDirFiles("templateSteps/typescript"),
  },

  react: {
    entryPoint: "App.tsx",
    defaultHasOutput: true,
    files: readDirFiles("templateSteps/react"),
  },

  agent: {
    entryPoint: "agent.ts",
    defaultHasOutput: false,
    files: readDirFiles("templateSteps/agent"),
  },
};

export const typescriptTemplateDockerfile = templateStepFiles.typescript.files.find(
  (f) => f.path === "Dockerfile"
)!.content;
